module.exports = __webpack_public_path__ + "static/image/history/m/202405@3x.png?6ba772c2";